// Copyright 1999-2024. WebPros International GmbH. All rights reserved.

export const USERS = {
    TABLE: 'users-table',
};

export const TABLE_ACTIONS = {
    SEND_RECOVERY_CODE: 'send-recovery-code',
    EDIT: 'edit',
    REMOVE: 'remove',
    BATCH_REMOVE: 'batch-remove',
};
